import { render, staticRenderFns } from "./pull-rules.vue?vue&type=template&id=b5fad4ea&scoped=true&"
import script from "./pull-rules.vue?vue&type=script&lang=js&"
export * from "./pull-rules.vue?vue&type=script&lang=js&"
import style0 from "./pull-rules.vue?vue&type=style&index=0&id=b5fad4ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fad4ea",
  null
  
)

export default component.exports